<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="searchCampaignList"
      :expand="expand"
      item-key="campaign_crypto_id"
      :loading="isLoading"
      :rows-per-page-items="[10, 50]"
    >
      <template v-slot:items="props">
        <tr>
          <td @click="props.expanded = !props.expanded">
            {{ items.indexOf(props.item) + 1 }}
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-center">
            {{ props.item.campaign_crypto_code }}
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-center">
            <img
              :src="props.item.campaign_crypto_image"
              alt
              width="50px"
              height="50px"
            />
          </td>
          <td @click="props.expanded = !props.expanded">
            {{ props.item.campaign_crypto_type }}
          </td>
          <td @click="props.expanded = !props.expanded">
            {{ props.item.campaign_crypto_title_th }}
          </td>
          <td @click="props.expanded = !props.expanded">
            {{ props.item.campaign_crypto_title_en }}
          </td>
          <td @click="props.expanded = !props.expanded">
            {{ props.item.campaign_crypto_description_th }}
          </td>
          <td @click="props.expanded = !props.expanded">
            {{ props.item.campaign_crypto_description_en }}
          </td>
          <td
            @click="props.expanded = !props.expanded"
            class="text-xs-center"
            v-if="props.item.campaign_crypto_type != 'airdrop'"
          >
            {{ props.item.campaign_crypto_amount_used }} /
            {{ props.item.campaign_crypto_amount_redeem }}
          </td>
          <td v-else class="text-xs-center">-</td>
          <td @click="props.expanded = !props.expanded" class="text-xs-center">
            {{ props.item.campaign_crypto_amount_point }}
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-center">
            {{ props.item.campaign_crypto_amount_token }}
          </td>
          <td @click="props.expanded = !props.expanded">
            {{ props.item.campaign_crypto_start_date || "-" }}
          </td>
          <td @click="props.expanded = !props.expanded">
            {{ props.item.campaign_crypto_end_date || "-" }}
          </td>

          <td>
            <v-btn icon @click="toViewCampaign(props.item.campaign_crypto_id)">
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>
          </td>
          <td>
            <v-switch
              v-if="props.item.campaign_crypto_type != 'airdrop'"
              :true-value="1"
              :false-value="0"
              v-model="props.item.campaign_crypto_status"
              hide-details
              @change="changeStatus(props.item)"
              color="primary"
            ></v-switch>
          </td>
          <td>
            <v-btn
              v-if="props.item.campaign_crypto_type != 'airdrop'"
              icon
              @click="toEditCampaign(props.item)"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <v-card flat>
          <v-card-text>
            <ul>
              <h3 style="color: cornflowerblue">Condition detail</h3>
              <li
                v-for="(info, index) in props.item
                  .campaign_crypto_condition_detail"
                :key="index"
              >
                {{ info.th }}
                <span style="color: grey"> {{ `(${info.en})` }}</span>
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </template>
    </v-data-table>
    <v-dialog v-model="viewDialog" persistent fullscreen hide-overlay>
      <v-card v-if="isLoadingDetail">
        <v-toolbar flat dark color="black">
          <v-toolbar-title>Transaction</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="viewDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="text-xs-center">
          <div class="spinner"></div>
          Please stand by
        </v-card-text>
      </v-card>
      <v-card v-else>
        <v-toolbar dark color="black">
          <v-toolbar-title>Transaction</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="viewDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-text-field
            prepend-icon="search"
            v-model="searchTransaction"
            placeholder="customer tel, customer name, wallet address, Ref.code"
          ></v-text-field>
          <v-data-table
            :headers="headersTransaction"
            :items="filteredTransactionList"
            :rows-per-page-items="[50, 100, 200]"
          >
            <template v-slot:items="props">
              <tr>
                <td>
                  {{ transactionList.indexOf(props.item) + 1 }}
                </td>
                <td>
                  {{ props.item.customer_tel }}
                </td>
                <td>
                  {{ props.item.customer_name }}
                </td>
                <td>
                  {{ props.item.crypto_transaction_wallet_address }}
                </td>
                <td class="text-xs-center">
                  {{ props.item.crypto_transaction_amount_token }}
                </td>

                <td>
                  {{ props.item.crypto_transaction_ref_id }}
                </td>
                <td
                  class="text-xs-center"
                  :style="{
                    color:
                      props.item.crypto_transaction_status == 1
                        ? 'grey'
                        : props.item.crypto_transaction_status == 2
                        ? 'deepskyblue'
                        : props.item.crypto_transaction_status == 3
                        ? 'green'
                        : props.item.crypto_transaction_status == 4
                        ? 'orange'
                        : 'red',
                    fontWeight: 'bold',
                  }"
                >
                  {{
                    showStatusTransaction(props.item.crypto_transaction_status)
                  }}
                </td>
                <td
                  class="text-xs-center"
                  v-if="props.item.crypto_transaction_datetime_pickup"
                >
                  {{
                    moment(
                      props.item.crypto_transaction_datetime_pickup
                    ).format("YYYY/MM/DD")
                  }}
                </td>
                <td class="text-xs-center" v-else style="color: red">-</td>
                <td class="text-xs-center">
                  {{
                    moment(props.item.create_at).format("YYYY/MM/DD HH:mm:ss")
                  }}
                </td>
                <td class="text-xs-center">
                  {{
                    moment(props.item.update_at).format("YYYY/MM/DD HH:mm:ss")
                  }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
export default {
  props: [
    "headers",
    "search",
    "filterType",
    "isLoading",
    "items",
    "campaignDetail",
  ],
  data() {
    return {
      searchTransaction: "",
      expand: false,
      viewDialog: false,
      isLoadingDetail: false,
      isDeleting: [],
      transactionList: [],
      headersTransaction: [
        {
          text: "#",
          align: "left",
          sortable: false,
        },
        {
          text: "Customer Tel.",
          align: "center",
          sortable: false,
        },
        {
          text: "Customer name",
          align: "center",
          sortable: false,
        },
        {
          text: "Wallet address",
          align: "center",
          sortable: false,
        },
        {
          text: "Amount token",
          align: "center",
          sortable: false,
        },
        {
          text: "Ref. code",
          align: "center",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
        },
        {
          text: "Date pickup",
          align: "center",
          sortable: false,
        },

        {
          text: "Created at",
          align: "center",
          sortable: false,
        },
        {
          text: "Last updated at",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    searchCampaignList() {
      return this.items.filter(
        (val) =>
          (val.campaign_crypto_title_th
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
            val.campaign_crypto_title_en
              .toLowerCase()
              .includes(this.search.toLowerCase())) &&
          (this.filterType == "all" ||
            this.filterType.toLowerCase() ==
              val.campaign_crypto_type.toLowerCase())
      );
    },
    filteredTransactionList() {
      return this.transactionList.filter(
        (val) =>
          val.customer_tel
            .toLowerCase()
            .includes(this.searchTransaction.toLowerCase()) ||
          val.customer_name
            .toLowerCase()
            .includes(this.searchTransaction.toLowerCase()) ||
          val.crypto_transaction_wallet_address
            .toLowerCase()
            .includes(this.searchTransaction.toLowerCase()) ||
          val.crypto_transaction_ref_id
            .toLowerCase()
            .includes(this.searchTransaction.toLowerCase())
      );
    },
    showCategory() {
      let category = [
        {
          name: "Normal",
          value: 1,
        },
        {
          name: "Order first time",
          value: 2,
        },
        {
          name: "Fix product price",
          value: 3,
        },
        {
          name: "Fix product price and fix store",
          value: 4,
        },
        {
          name: "Fix product",
          value: 5,
        },
        {
          name: "Fix store",
          value: 6,
        },
      ];
      let findObject = category.find(
        (val) => val.value == this.campaignDetail.campaign_promotion_category
      );
      return findObject ? findObject.name : "";
    },
  },
  methods: {
    ...mapActions({
      updateCampaignCrypto: "campaigns/updateCampaignCrypto",
      fetchTransactionCryptoById: "campaigns/fetchTransactionCryptoById",
    }),
    moment,
    showStatusTransaction(status) {
      if (status == 1) {
        return "รอรับ";
      } else if (status == 2) {
        return "กำลังดำเนินการ";
      } else if (status == 3) {
        return "สำเร็จ";
      } else if (status == 4) {
        return "ไม่สำเร็จ";
      } else if (status == 5) {
        return "ยกเลิก";
      }
      return "";
    },
    async changeStatus(item) {
      let payload = {
        campaign_crypto_id: item.campaign_crypto_id,
        campaign_crypto_status: item.campaign_crypto_status,
      };
      let result = await this.updateCampaignCrypto(payload);
      if (result == true) return;
      if (item.campaign_crypto_status == 0) {
        item.campaign_crypto_status = 1;
      } else if (item.campaign_crypto_status == 1) {
        item.campaign_crypto_status = 0;
      }
    },
    async toEditCampaign(item) {
      this.$emit("toEdit", item);
    },
    async toViewCampaign(ID) {
      this.isLoadingDetail = true;
      this.viewDialog = true;
      this.transactionList = [];
      this.transactionList = await this.fetchTransactionCryptoById(ID);
      this.isLoadingDetail = false;
      this.searchTransaction = "";
    },
  },
};
</script>

<style scoped>
.dialogcontent--title {
  font-size: 22px;
  text-decoration: underline;
  padding-bottom: 16px;
}
.dialogcontent--subtitle {
  font-size: 20px;
}

.dialogcontent--value {
  font-size: 18px;
  color: grey;
}

.spinner {
  width: 40px;
  height: 40px;
  background-color: #333;

  margin: 20px auto;
  -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
  animation: sk-rotateplane 1.2s infinite ease-in-out;
}

@-webkit-keyframes sk-rotateplane {
  0% {
    -webkit-transform: perspective(120px);
  }
  50% {
    -webkit-transform: perspective(120px) rotateY(180deg);
  }
  100% {
    -webkit-transform: perspective(120px) rotateY(180deg) rotateX(180deg);
  }
}

@keyframes sk-rotateplane {
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);
  }
  50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
  }
  100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
}
</style>
